import React from 'react';
import { MenuItem, Select, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ExpiryTimeDropdown = ({ selectedExpiration, handleExpireTimeValue }) => {
  const expTime = [
    {
      title: '5 Mins',
      time: '5m',
    },
    {
      title: '12 Hours',
      time: '12h',
    },
    {
      title: '1 Day',
      time: '1d',
    },
    {
      title: '2 Days',
      time: '2d',
    },
    {
      title: '3 Days',
      time: '3d',
    },
    {
      title: '5 Days',
      time: '5d',
    },
    {
      title: '1 Week',
      time: '1w',
    },
  ];
  return (
    <Select
      fullWidth
      size="small"
      value={selectedExpiration}
      onChange={(event) => {
        handleExpireTimeValue(event.target.value);
      }}
      renderValue={(selected) => <Typography>{selected.title}</Typography>}
    >
      {expTime?.map((option) => (
        <MenuItem key={option} value={option}>
          <Typography>{option.title}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
};

ExpiryTimeDropdown.propTypes = {
  selectedExpiration: PropTypes.shape({
    title: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
  }).isRequired,
  handleExpireTimeValue: PropTypes.func.isRequired,
};
export default ExpiryTimeDropdown;
